export default "__VITE_ASSET__kJt6veBV__"